import type { Category, ICategoryInterface, Product } from "@magento/types";
import { normalizeProductNicotineStrengthData } from "@magento/utils";

export const mapGetCartItemsLineToProduct = (item: unknown, points = 0, rules: Product["rules"] = []): Product => {
  const {
    id,
    errors,
    has_registration_consent,
    product: {
      sku,
      stock_status,
      name,
      image: { url: imageUrl },
      short_description: { html: description },
      flavor,
      flavor_label,
      color_label,
      subtitle,
      categories,
      enable_order_quantity_limit,
      order_quantity_limit,
      price_range,
      free_gifts,
      trade_in,
      type_id,
      promotionalOffers,
      subscription,
      subscription_format,
      has_device,
      is_discontinued,
      delivery_region_code,
      strength_details,
    },
    prices,
    gift_data,
    quantity,
    bundle_options,
    configured_variant,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- GraphQL cart line union;
  } = item as any;

  const decodedCategories: Category[] = (categories ?? []).map((category: ICategoryInterface) => ({
    name: category.name,
    uid: Number(atob(category.uid)),
    store_locator_name: category.store_locator_name,
  }));

  return {
    id,
    name,
    sku,
    has_registration_consent,
    status: stock_status,
    imageUrl,
    quantity,
    description,
    price: prices.price,
    prices,
    flavor,
    flavor_label,
    color_label,
    subtitle,
    categories: decodedCategories,
    enable_order_quantity_limit,
    order_quantity_limit,
    points: points ? points : 0,
    rules,
    price_range,
    free_gifts,
    tradeIn: trade_in || false,
    type_id,
    isGift: gift_data?.is_gift || false,
    isGiftRemovable: gift_data?.is_gift_removable || false,
    isDiscontinued: is_discontinued || configured_variant?.is_discontinued || false,
    parentGiftSku: gift_data?.parent_gift_sku || "",
    parentGiftId: gift_data?.parent_gift_id || "",
    bundle_options,
    promotionalOffers,
    subscription,
    subscription_format,
    delivery_region_code: delivery_region_code ?? undefined,
    errors,
    hasDevice: has_device || false,
    nicotineStrength: normalizeProductNicotineStrengthData(strength_details),
  };
};
